import { useSyncExternalStore } from 'react';
import { load, save } from './storage.ts';

export interface Settings {
  sound: boolean;
  showLegalMoves: boolean;
  /** Variant helpers: snail paths, danger squares, countdown badges… */
  showHints: boolean;
  coordinates: boolean;
}

const DEFAULTS: Settings = { sound: true, showLegalMoves: true, showHints: true, coordinates: true };
const listeners = new Set<() => void>();
let current: Settings = { ...DEFAULTS, ...load<Partial<Settings>>('settings', {}) };

export function getSettings(): Settings {
  return current;
}

export function updateSettings(patch: Partial<Settings>) {
  current = { ...current, ...patch };
  save('settings', current);
  for (const l of listeners) l();
}

export function useSettings(): Settings {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
